export const generalMessageTemplate = {
    game: {
     
      secondsToWaitForUsers: null,
      startDate: null,
      endDate: null,
      gameId: null,
      gameStatus: null,
      pointsWin: null,
      pointsLose: null,
      pointsDraw: null,
      maxTeamMembers: null,
      minTeamMembers: null,
      whiteMoves: null,
      blackMoves: null,
      currentTurn: null,
      initialFen: null,
      currentFen: null,
      whiteTeam: [],
      blackTeam: [],
      all: [],
      gameTimeType: null,
      secondsBasedOnGameTimeType: null,
      gameTeamType: null,
    },
    move: {
      
      color: null,
      userMove: null,
      userFen: null,
      commandMove: null,
      commandFen: null,
      bestMove: null,
      bestFen: null,
      secondsForMove: null,
    },
    messageType: null,
    sessionId: null,
    user: {
      userId: null,
      userName: null,
      firstName: null,
      secondName: null,
      userStatistics: {
        totalGames: null,
        totalWins: null,
        totalLose: null,
        totalDraw: null,
        currentScore: null,
        bestScore: null,
        league: null,
        rating: null,
      }
    },
    color: null
  };